module.exports = __webpack_public_path__ + "img/box1_icon8.2e910ea1.png";